// import { captureRemixErrorBoundaryError } from "@sentry/remix";
import type { LinksFunction } from "react-router";
import {
  isRouteErrorResponse,
  Link,
  Links,
  Meta,
  MetaFunction,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
} from "react-router";

import "./tailwind.scss";
import { Toaster } from "react-hot-toast";

export const links: LinksFunction = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
  },
  {
    rel: "manifest",
    href: "/manifest.json",
  },
  {
    rel: "icon",
    type: "image/png",
    href: "/favicon-96x96.png",
    sizes: "96x96",
  },
  { rel: "icon", type: "image/svg+xml", href: "/favicon.svg" },
  { rel: "shortcut icon", href: "/favicon.ico" },
  { rel: "apple-touch-icon", sizes: "180x180", href: "/apple-touch-icon.png" },

];

export const meta: MetaFunction = () => {
  return [
    { title: "DAV Admin" },
    { name: "description", content: "DAV Admin" },
  ]
};

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="it">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        <meta name="theme-color" content="#000000" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="apple-mobile-web-app-title" content="Compositore DAV" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export function ErrorBoundary() {
  const error = useRouteError();

  let message = "Si è verificato un errore inaspettato.";
  let status: number | undefined;

  if (isRouteErrorResponse(error)) {
    status = error.status;
    message = (error.data as string) || error.statusText;
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-base-200 text-center p-4">
      <div className="max-w-lg w-full card shadow-xl bg-base-100 p-8">
        <h1 className="text-3xl font-bold text-error mb-4">Errore</h1>
        {status && <p className="text-lg font-medium mb-2">Codice: {status}</p>}
        <p className="mb-6">{message}</p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={() => location.reload()}
            className="btn btn-primary"
          >
            Ricarica la pagina
          </button>
          <Link to="/" className="btn btn-outline">
            Torna alla Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return <><Outlet /><Toaster
    position="top-center"
    reverseOrder={false}
  /></>;
}